(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('ModalConfirmController', ModalConfirmController);

    ModalConfirmController.$inject = ['$uibModalInstance', 'name', 'title', 'descriptionPrefix'];

    function ModalConfirmController($uibModalInstance, name, title, descriptionPrefix) {
        var self = this;

        self.title = title;
        self.description = descriptionPrefix + ' ' + name + '?';

        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            $uibModalInstance.close();
        }

        function cancel() {
            $('.wrapper-content').removeClass('animated');
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
